import type { ReactNode } from 'react'
import { useKonami } from 'react-konami-code'

import useFeatureFlags from '@/hooks/useFeatureFlags'
import useUserPermissions from '@/hooks/useUserPermissions'
import { useUiStore } from '@/stores/ui.store'

const AppWrapper = ({ children }: { children: ReactNode }) => {
  const developerMode = useUiStore((store) => store.developerMode)
  const setDeveloperMode = useUiStore((store) => store.setDeveloperMode)

  useKonami(() => setDeveloperMode(!developerMode), { code: [68, 69, 86] })

  useFeatureFlags()
  useUserPermissions()

  return <>{children}</>
}

export default AppWrapper
